function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useGetUserClaimAbilities } from '../../userAbilities';
import { FormattedNumberInput } from '@rd-web-markets/shared/dist/util';
import { CURRENCY_FORMATTER } from '../../constants';
import { Card, Table } from 'react-bootstrap';
import ChangeHighlightedImmutableUnderReviewControl from '@rd-web-markets/shared/dist/util/reviewEditControls/ChangeHighlightedImmutableUnderReviewControl';
export default function TotalCostData(_ref) {
  var _claim$enhancement_am, _claim$enhanced_expen;
  let {
    claim,
    setClaim,
    saveClaim
  } = _ref;
  const handleChange = useCallback(e => {
    setClaim(_objectSpread(_objectSpread({}, claim), {}, {
      [e.target.name]: e.target.value
    }));
  }, [claim, setClaim]);
  const user = useSelector(state => state.auth.user);
  const pageAbilities = useGetUserClaimAbilities({
    user,
    claim
  }).pages.TotalCosts;
  const renderCostField = fieldName => {
    if (pageAbilities.canDirectlyEditTotalCosts) {
      return /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
        as: FormattedNumberInput,
        onChange: handleChange,
        onBlur: () => saveClaim(claim),
        disabled: claim.financials_locked,
        name: fieldName,
        object: _objectSpread({}, claim),
        size: "sm",
        type: "text"
      });
    } else {
      return /*#__PURE__*/React.createElement("span", {
        className: "form-control form-control-sm text-end border-0 bg-transparent p-0"
      }, "\xA3 ", CURRENCY_FORMATTER.format(claim[fieldName]));
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Card.Header, {
    className: "bg-secondary text-primary"
  }, "Qualifying R&D expenditure"), /*#__PURE__*/React.createElement(Table, {
    striped: true
  }, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, "Staffing costs (note 1)"), /*#__PURE__*/React.createElement("td", {
    className: "text-end"
  }, renderCostField('employee_qualifying_rnd_expenditure'))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, "Subcontracting (note 2)"), /*#__PURE__*/React.createElement("td", {
    className: "text-end"
  }, renderCostField('subcontractor_qualifying_rnd_expenditure'))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, "Externally provided workers  (note 3)"), /*#__PURE__*/React.createElement("td", {
    className: "text-end"
  }, renderCostField('external_workers_rnd_amount_total'))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, "R&D Consumables (note 4)"), /*#__PURE__*/React.createElement("td", {
    className: "text-end"
  }, renderCostField('consumable_qualifying_rnd_expenditure'))), /*#__PURE__*/React.createElement("tr", {
    style: {
      borderBottom: 'solid 2px black'
    }
  }, /*#__PURE__*/React.createElement("td", null, "Software (note 5)"), /*#__PURE__*/React.createElement("td", {
    className: "text-end"
  }, renderCostField('software_consumables_qualifying_rnd_expenditure'))), /*#__PURE__*/React.createElement("tr", {
    style: {
      borderBottom: 'solid 2px black'
    }
  }, /*#__PURE__*/React.createElement("td", null, "Cloud Computings (note 6)"), /*#__PURE__*/React.createElement("td", {
    className: "text-end"
  }, renderCostField('cloud_computings_qualifying_rnd_expenditure'))), /*#__PURE__*/React.createElement("tr", {
    style: {
      borderBottom: 'solid 2px black'
    }
  }, /*#__PURE__*/React.createElement("td", null, "Data Licences Cost (note 7)"), /*#__PURE__*/React.createElement("td", {
    className: "text-end"
  }, renderCostField('data_licences_costs_qualifying_rnd_expenditure'))), /*#__PURE__*/React.createElement("tr", {
    style: {
      borderBottom: 'solid 2px black'
    }
  }, /*#__PURE__*/React.createElement("td", null, "Independent RnD Contribution (note 8)"), /*#__PURE__*/React.createElement("td", {
    className: "text-end"
  }, renderCostField('independent_rnd_contributions_qualifying_rnd_expenditure'))), /*#__PURE__*/React.createElement("tr", {
    style: {
      borderBottom: 'solid 2px black'
    }
  }, /*#__PURE__*/React.createElement("td", null, "Payments to Clinical Trials (note 9)"), /*#__PURE__*/React.createElement("td", {
    className: "text-end"
  }, renderCostField('payments_to_clinical_trials_qualifying_rnd_expenditure'))), /*#__PURE__*/React.createElement("tr", {
    style: {
      borderBottom: 'solid 2px black'
    }
  }, /*#__PURE__*/React.createElement("td", null, "Amount that is Qualifying Indirect Activities"), /*#__PURE__*/React.createElement("td", {
    className: "text-end"
  }, renderCostField('qualifying_indirect_activities_expenditure'))), claim.is_long_claim_period ? /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null), /*#__PURE__*/React.createElement("th", {
    className: "text-end"
  }, "CT 1"), /*#__PURE__*/React.createElement("th", {
    className: "text-end"
  }, "CT 2")) : null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("strong", null, "TOTAL QUALIFYING R&D EXPENDITURE")), /*#__PURE__*/React.createElement("td", null, claim.total_qualifying_rnd_expenditure.map((value, index) => /*#__PURE__*/React.createElement("div", {
    className: "text-end form-control-sm",
    key: index
  }, /*#__PURE__*/React.createElement("strong", null, "\xA3 ", CURRENCY_FORMATTER.format(value)))))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("strong", null, "R&D ENHANCEMENT FOR TAX COMPUTATION")), /*#__PURE__*/React.createElement("td", null, (_claim$enhancement_am = claim.enhancement_amount) === null || _claim$enhancement_am === void 0 ? void 0 : _claim$enhancement_am.map((value, index) => /*#__PURE__*/React.createElement("div", {
    className: "text-end form-control-sm",
    key: index
  }, /*#__PURE__*/React.createElement("strong", null, "\xA3 ", CURRENCY_FORMATTER.format(value)))))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("strong", null, "ENHANCED R&D EXPENDITURE DISCLOSURE FOR CT600")), /*#__PURE__*/React.createElement("td", null, (_claim$enhanced_expen = claim.enhanced_expenditure) === null || _claim$enhanced_expen === void 0 ? void 0 : _claim$enhanced_expen.map((value, index) => /*#__PURE__*/React.createElement("div", {
    className: "text-end form-control-sm",
    key: index
  }, /*#__PURE__*/React.createElement("strong", null, "\xA3 ", CURRENCY_FORMATTER.format(value))))))))));
}